// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"17731974","455":"8f0eb4ae"}[chunkId] + ".chunk.js";
};